import { render, staticRenderFns } from "./56modelBorder.vue?vue&type=template&id=6d52ed10&scoped=true&"
import script from "./56modelBorder.vue?vue&type=script&lang=js&"
export * from "./56modelBorder.vue?vue&type=script&lang=js&"
import style0 from "./56modelBorder.vue?vue&type=style&index=0&id=6d52ed10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52ed10",
  null
  
)

export default component.exports